import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-mp4-file-icon',
  templateUrl: './doc-format-mp4-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatMp4FileIconComponent {}
